module.exports = __webpack_public_path__ + "static/media/tti_reason_2@2x.e17adb44.png";